import { GiftPlanType } from '@/features/cms/components/CMS/components/GiftCardPurchaseForm/constants'
import { type GiftCardFormInput } from '@/features/cms/components/CMS/components/GiftCardPurchaseForm/GiftCardRecipientForm'
import { type GiftCards } from '@/features/cms/components/CMS/types'

export const getGiftCardChoiceAnalyticsMessageGoal = (cardChoice: string) => {
  switch (cardChoice) {
    case GiftPlanType.GROCERY_YEARLY: {
      return 'gift_membership_annual99'
    }
    case GiftPlanType.GROCERY_SIX_MONTHS: {
      return 'gift_membership_6months49'
    }
    default: {
      return `gift_card_amount${cardChoice}`
    }
  }
}
export const getDefaultFormValues = (dataArg: GiftCards, validLocalData?: GiftCardFormInput) => ({
  giftImage: validLocalData?.giftImage ?? {
    src: dataArg.gift_cards[0]?.data.image.src,
    alt: dataArg.gift_cards[0]?.data.image.alt,
  },
  cardChoice: validLocalData?.cardChoice ?? '100',
  recipientName: validLocalData?.recipientName ?? '',
  recipientEmail: validLocalData?.recipientEmail ?? '',
  personalMessage: validLocalData?.personalMessage ?? '',
  senderName: validLocalData?.senderName ?? '',
  senderEmail: validLocalData?.senderEmail ?? '',
  termsAndConditions: validLocalData?.termsAndConditions ?? false,
})
export const GIFT_CARD_FORM_DATA = 'gift_card_form_data'

export function isInvalidGiftCardValue(value: string) {
  return Number(value) > 250 || Number(value) < 25
}

const MEMBERSHIP_LABELS: Record<string, string> = {
  [GiftPlanType.GROCERY_YEARLY]: 'Annual',
  [GiftPlanType.GROCERY_SIX_MONTHS]: '6-month',
}

/**
 * Returns true when the backend membership `value` is known to FE
 */
export const isKnownMembershipPlan = (value: string): boolean =>
  Object.prototype.hasOwnProperty.call(MEMBERSHIP_LABELS, value)

/**
 * Map a backend membership `value` enum to a display label
 */
export const getMembershipLabel = (value: string): string =>
  isKnownMembershipPlan(value) ? (MEMBERSHIP_LABELS[value] ?? value) : value
